module.exports = __webpack_public_path__ + "img/wending@2x.9d5e07f0.png";